import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage } from '../data/copy';
const contents = ['6 Complete Teaching Volumes', '120 Ready-to-Teach Classes', '7 Practical Teacher Bonuses'];
export function Hero() {
  return <header className="w-full bg-ivory" data-id="element-93" data-mp="4mru70n4vzl8">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-7 text-center sm:pt-9 lg:pb-12" data-id="element-94" data-mp="4jm5hmif2zq1">
        <Pill tone="sage" className="mx-auto max-w-[19rem] text-center leading-[1.7] sm:max-w-none" data-id="element-95" data-mp="128pi5dka8x4k">
          For yoga teachers tired of planning every class from scratch
        </Pill>

        <h1 className="mx-auto mt-4 max-w-3xl font-display text-[1.9rem] leading-[1.08] text-ink sm:text-5xl lg:text-[3.5rem]" data-id="element-96" data-mp="s9q75oc1opee">
          6 Months of Yoga Classes.{' '}
          <span className="text-sage" data-id="element-97" data-mp="3d1sc51sntrv8">Ready to Teach</span>
        </h1>

        {/* The complete product mockup sits directly under the question. */}
        <div className="relative mt-7" data-id="element-98" data-mp="384jsewrv5frv">
          <div className="absolute inset-x-0 bottom-6 top-12 rounded-4xl bg-sand" aria-hidden="true" data-id="element-99" data-mp="3j7zh7oa6s2jb" />
          <img src={heroImage} alt="The complete Yoga Teaching Vault™: six teaching volumes, seven bonus books and printable teaching resources." className="relative mx-auto w-full max-w-[19rem] sm:max-w-lg lg:max-w-2xl" width={1240} height={1240} sizes="(max-width: 640px) 304px, (max-width: 1024px) 512px, 672px" decoding="async" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-100" data-mp="3o858328mtl0c" />
        </div>

        
        <p className="mx-auto mt-3 max-w-readable font-sans text-[0.95rem] leading-relaxed text-stone sm:text-base" data-id="element-101" data-mp="359jahxcbqc16">
          The complete ready-to-teach system for yoga teachers who want to plan
          less and never wonder “what am I teaching tomorrow?” again.
        </p>

        {/* First CTA — jumps straight to the offer section, where the price is. */}
        <div className="mt-6" data-id="element-102" data-mp="2lkiiu1e2bo64">
          <CtaButton href="#offer" size="large" className="w-full sm:w-auto" data-id="element-103" data-mp="2ljgy1578vnb7">
            Get Yoga Teaching Vault™
          </CtaButton>
        </div>

        <ul className="mx-auto mt-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 font-sans text-[0.72rem] font-medium uppercase tracking-[0.1em] text-sage-deep sm:text-[0.8rem]" data-id="element-104" data-mp="nbbcixheu94r">
          {contents.map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-105" data-mp="ddnenyoiclid" data-mpi={index}>
              {item}
              {index < contents.length - 1 ? <span className="h-1 w-1 rounded-full bg-gold" aria-hidden="true" data-id="element-106" data-mp="1azullf8aapxw" /> : null}
            </li>)}
        </ul>

        <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-107" data-mp="162c95ev25sl5">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone sm:text-xs" data-id="element-108" data-mp="110wnployxk28">
              <CheckIcon className="h-3.5 w-3.5 text-sage" strokeWidth={2.4} aria-hidden="true" data-id="element-109" data-mp="x37cyf6yybc5" />
              {badge}
            </li>)}
        </ul>
      </div>
    </header>;
}